import { Participant, ParticipantTracks } from './video-call-participant';

export enum VIDEO_CALL_EVENT_TYPE {
    HUNG_UP = 'hungUp',
    INVITATION_SENT = 'invitationSent',
    JOINED_PARTICIPANT = 'joinedParticipant',
    LEFT_PARTICIPANT = 'leftParticipant',
    TRACK_STARTED = 'trackStarted',
    TRACK_STOPPED = 'trackStopped',
    TURN_OFF_MICROPHONE = 'turnOffMicrophone',
    TURN_ON_MICROPHONE = 'turnOnMicrophone',
}

export type VideoCallEvent =
    | HungUpVideoCallEvent
    | JoinedParticipantVideoCallEvent
    | LeftParticipantVideoCallEvent
    | TrackStartedVideoCallEvent
    | TrackStoppedVideoCallEvent
    | TurnOffMicVideoCallEvent
    | TurnOnMicVideoCallEvent;

export type JoinedParticipantVideoCallEvent = {
    type: VIDEO_CALL_EVENT_TYPE.JOINED_PARTICIPANT;
    participant: Participant;
};

export type LeftParticipantVideoCallEvent = {
    type: VIDEO_CALL_EVENT_TYPE.LEFT_PARTICIPANT;
    participant: Participant;
};

export type TrackStartedVideoCallEvent = {
    type: VIDEO_CALL_EVENT_TYPE.TRACK_STARTED;
    participantTracks: ParticipantTracks;
};

export type HungUpVideoCallEvent = {
    type: VIDEO_CALL_EVENT_TYPE.HUNG_UP;
};

export type TrackStoppedVideoCallEvent = {
    type: VIDEO_CALL_EVENT_TYPE.TRACK_STOPPED;
    participantTracks: ParticipantTracks;
};

export type TurnOnMicVideoCallEvent = {
    type: VIDEO_CALL_EVENT_TYPE.TURN_ON_MICROPHONE;
};

export type TurnOffMicVideoCallEvent = {
    type: VIDEO_CALL_EVENT_TYPE.TURN_OFF_MICROPHONE;
};
